<input *ngIf="type !== 'number'; else numberTmp"
       [type]="type"
       [formControl]="formControl"
       class="form-control"
       [ngClass]="props.class"
       [formlyAttributes]="field"
       [class.is-invalid]="showError" />
<ng-template #numberTmp>
    <input type="number"
           [formControl]="formControl"
           class="form-control"
           [ngClass]="props.class"
           [formlyAttributes]="field"
           [class.is-invalid]="showError" />
</ng-template>